import { createValidator } from 'revalidate';
import { THE_FIELD_HAS_NOT_THE_SAME_VALUE } from '../constants/defaultErrorMessages';
import { getFieldValue } from '../utils/utils';
const matchesField = otherField => createValidator(message => (value, allValues) => {
  const otherValue = getFieldValue(allValues, otherField);
  if (!value) {
    return null;
  }
  if (!allValues || (otherValue && value.toLowerCase()) !== (otherValue === null || otherValue === void 0 ? void 0 : otherValue.toLowerCase())) {
    return message || THE_FIELD_HAS_NOT_THE_SAME_VALUE;
  }
  return null;
}, THE_FIELD_HAS_NOT_THE_SAME_VALUE);
export default matchesField;
//# sourceMappingURL=matchesField.js.map